import { memo, useCallback } from "react";
import { RenderItemMenuProps } from "../types";
import { getLabel } from "../utils";

const LinkItem = ({
  item,
}: {
  item: RenderItemMenuProps<API.LinkMenuItem>;
}) => {
  const label = getLabel(item);

  const { url, openNewTab } = item.itemProps;

  const onClick = useCallback(() => {
    if (openNewTab) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  }, []);

  return (
    <button
      type="button"
      className="button--reset topMenu-link"
      onClick={onClick}
      key={item.name}
    >
      {label}
    </button>
  );
};

export default memo(LinkItem);
